import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';
import type { ReportConfigurationProps } from 'app-components/flux/report-configurations/reportConfigurationsTypes';

export type REPORT_CONFIGURATION_DEFAULTS_ERROR_PAYLOAD = unknown;

export const getReportConfigurationDefaults = createAction('GET_REPORT_CONFIGURATION_DEFAULTS', getPayloadCreator());

export const getReportConfigurationDefaultsSuccess = createAction(
  'GET_REPORT_CONFIGURATION_DEFAULTS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<ReportConfigurationProps>>(),
);

export const getReportConfigurationDefaultsFailure = createAction(
  'GET_REPORT_CONFIGURATION_DEFAULTS_FAILURE',
  getPayloadCreator<REPORT_CONFIGURATION_DEFAULTS_ERROR_PAYLOAD>(),
);
